import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code"]

  toggle() {
    console.log("toggle")
    this.codeTarget.classList.toggle("hidden")
  }
}